import { useMemo } from 'react';
import { MessageSectionController } from './messageSectionInterface';
import { formatDateHeader } from '../../integration/page/thread/common/threadCommonHelper';
import { MessageSectionViewProps } from './messageSectionProps';
import { MessageGroupContainerProps } from '../group';
import { groupMessagesInSection } from './messageSectionHelper';

export function createMessageSectionController(): MessageSectionController {
    return {
        useProps(context, item, props): MessageSectionViewProps {
            const messageGroups = useMemo(
                () => groupMessagesInSection(item.messages),
                [item.messages]
            );
            return {
                date: item.date,
                label: formatDateHeader(item.date),
                groups: messageGroups.map(
                    (group): Omit<MessageGroupContainerProps, 'as'> => ({
                        item: group,
                    })
                ),
            };
        },
    };
}
